import PropTypes from 'prop-types';

import { ShareButton } from '../../pieces/ShareButton';
import { Votes } from '../../pieces/Votes';

export function Footer({
  upvotes,
  downvotes,
  isUpvoted,
  isDownvoted,
  handleUpvoteAction,
  handleDownvoteAction,
  handleShareAction,
}) {
  return (
    <div className="not-prose mt-2 flex items-center justify-between text-xs opacity-90 group-hover:opacity-100 sm:text-sm">
      <div className="inline-flex items-center gap-3">
        <Votes
          upvotes={upvotes}
          downvotes={downvotes}
          isUpvoted={isUpvoted}
          isDownvoted={isDownvoted}
          handleUpvoteButton={handleUpvoteAction}
          handleDownvoteButton={handleDownvoteAction}
        />
      </div>
      <ShareButton handleClick={handleShareAction} />
    </div>
  );
}

Footer.propTypes = {
  upvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  downvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isUpvoted: PropTypes.bool,
  isDownvoted: PropTypes.bool,
  handleUpvoteAction: PropTypes.func.isRequired,
  handleDownvoteAction: PropTypes.func.isRequired,
  handleShareAction: PropTypes.func.isRequired,
};
